import axios from 'axios'
import { Message } from 'element-ui'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: '/api',
  // 超时
  timeout: 30000
})

// request拦截器
service.interceptors.request.use(config => {
  // console.log(config)
  return config;
})

// 响应拦截器
service.interceptors.response.use(res => {
  if(res.status != 200) {
    Message.error("请求数据错误");
    return Promise.reject('error');
  }

  if(res.data.code != 200) {
    if(res.data.code == 401) {
      //token失效，重新返回登录页面
      location.href = '/login';
    }
    Message.error(res.data.msg);
    return Promise.reject('error');
  }

  // console.log(res)
  return res.data;
})

export default service
